
/* injects from baggage-loader */

'use strict';

import DialogAlertController from '../alert/alert.controller';

export default class DialogApresentationController extends DialogAlertController {
    constructor($log, $rootScope) {
        'ngInject';

        super($log, $rootScope);

        this.$log = $log;

        this.state = {
          step: 0
        }
    }

    nextStep(){
      if ( this.state.step < ( this.resolve.texts.length - 1 ) ){
        this.state.step = this.state.step + 1;
      }
    }

    ok(){
      return this.state.step === (this.resolve.texts.length - 1) ? super.ok() : false
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/apresentation/apresentation.controller.js